import {
  Button,
  CircularProgress,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
  Link,
  Text,
} from '@chakra-ui/react';
import { useCreateEmissorModalContext } from './CreateEmissorModalContext';

interface CreateEmissorModalProps {
  isOpen: boolean;
  onClose(): void;
}

const CONVERTER_URL =
  'https://yooga-update.s3-sa-east-1.amazonaws.com/Criar_Token.rar';

const CreateEmissorModal: React.FC<CreateEmissorModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { loading, fileName, errors, handleFileChange, handleSubmit } =
    useCreateEmissorModalContext();

  return (
    <Drawer isOpen={isOpen} onClose={onClose} size="lg" placement="right">
      <DrawerOverlay />
      <DrawerContent pos="relative">
        <DrawerCloseButton />
        <DrawerHeader>Criar novo emissor</DrawerHeader>

        <DrawerBody>
          <Flex direction="column" gap="1rem">
            <Text fontSize="sm">
              Envie o JSON gerado pelo conversor xlsx → JSON (mesmo formato do
              admin legado).
            </Text>

            <Link
              href={CONVERTER_URL}
              isExternal
              color="yooga.500"
              fontSize="sm"
            >
              Download do conversor de xlsx para JSON
            </Link>

            <FormControl
              isRequired
              isInvalid={!!errors.file || !!errors.cnpj || !!errors.customer}
            >
              <FormLabel>Arquivo JSON do emissor</FormLabel>
              <Input
                type="file"
                accept=".json,application/json"
                onChange={(e) => handleFileChange(e.target.files?.[0] ?? null)}
                p={1}
              />
              {fileName && (
                <FormHelperText>Arquivo selecionado: {fileName}</FormHelperText>
              )}
              {errors.file && (
                <FormErrorMessage>{errors.file}</FormErrorMessage>
              )}
              {errors.cnpj && (
                <FormErrorMessage>{errors.cnpj}</FormErrorMessage>
              )}
              {errors.customer && (
                <FormErrorMessage>{errors.customer}</FormErrorMessage>
              )}
            </FormControl>
          </Flex>
        </DrawerBody>

        <DrawerFooter>
          <Button
            colorScheme="yooga"
            onClick={handleSubmit}
            w="100%"
            isDisabled={loading}
          >
            Criar emissor
          </Button>
        </DrawerFooter>

        {loading && (
          <Flex
            pos="absolute"
            top="0"
            left="0"
            w="100%"
            h="100%"
            bg="gray.100"
            zIndex="1"
            align="center"
            justify="center"
          >
            <CircularProgress isIndeterminate color="yooga.400" />
          </Flex>
        )}
      </DrawerContent>
    </Drawer>
  );
};

export default CreateEmissorModal;
